import { ReactNode } from 'react';

import { createDependenciesContext, TranslatableText } from '@dreryk/react-common';
import { ButtonVariant } from '@dreryk/react-components';

type AccountConfigurationVerificationEventInterceptorConstructor = (props: { children: ReactNode }) => JSX.Element;

type AppointmentOutOfScheduleButtonConstructor = (props: {
   patientId: number;
   compact?: boolean;
   accountConfigurationVerificationEventInterceptor: AccountConfigurationVerificationEventInterceptorConstructor;
   goBackButtonLabel?: TranslatableText;
}) => JSX.Element | null;

type VisitsHistoryPanel = {
   AnnulledVisitsPreferenceVisibilityCheckbox: () => JSX.Element;
   VisitsHistoryInfiniteList: (props: { patientId: number }) => JSX.Element;
};

type VisitsHistoryButtonConstructor = (props: { patientId: number }) => JSX.Element;

type ShowVisitButtonConstructor = (props: {
   visitId: number;
   patientId: number;
   label: TranslatableText;
   backActionLabel: TranslatableText;
   variant?: ButtonVariant;
   disabled?: boolean;
}) => JSX.Element;

export type PatientDependencies = {
   appointmentOutOfScheduleButton: AppointmentOutOfScheduleButtonConstructor | null;
   visitHistoryPanel: VisitsHistoryPanel;
   accountConfigurationVerificationEventInterceptor: AccountConfigurationVerificationEventInterceptorConstructor;
   visitsHistoryButton: VisitsHistoryButtonConstructor;
   showVisitButton: ShowVisitButtonConstructor;
};

const [usePatientDependenciesContext, PatientDependenciesContextProvider] = createDependenciesContext<
   PatientDependencies & { contextName: 'Patient' }
>('Patient');

export { PatientDependenciesContextProvider, usePatientDependenciesContext };
